import { Tabs } from "antd";
import { useLocation } from "react-router-dom";
import ServiceReturnEntry from "./ServiceReturnEntry";
import ServiceReturnRecord from "./ServiceReturnRecord";
import ServiceReturnVoucher from "./ServiceReturnVoucher";
import { accessChecker } from "../../../lib/functions";

const ServiceReturn = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const activeTab = params.get("tab") || "entry";

  const menuData = [
    {
      label: "Service Return Entry",
      key: "entry",
      value: "service_return",
      children: <ServiceReturnEntry />,
    },
    {
      label: "Service Return Record",
      key: "record",
      value: "service_return_record",
      children: <ServiceReturnRecord />,
    },
    {
      label: "Service Return Voucher",
      key: "voucher",
      value: "service_return_voucher",
      children: <ServiceReturnVoucher key={location.search} />,
    },
  ];

  const filteredMenuData = menuData.filter((menuItem) => accessChecker(menuItem.value));

  return (
    <Tabs
      key={activeTab}
      defaultActiveKey={activeTab}
      type="card"
      size="medium"
      style={{ marginBottom: 32 }}
      items={filteredMenuData}
    />
  );
};

export default ServiceReturn;
